import React, { Component } from "react";
import FilterSelectAddFilterButton from "./FilterSelectAddFilterButton";
import { isPropsForLogicalOperator } from "./LogicalOperatorsOptions";

/**
 * Allow to add elements into a list to be use as reference for Contains LO
 */
class LogicalOperatorContainsView extends Component {
  constructor(props) {
    super();
    this.state = isPropsForLogicalOperator(props)
      ? props.logicalOperator.value
      : {
          value: "",
          list: [],
        };
  }

  onChange = (e) => {
    this.setState({ value: e.target.value });
  };

  onAddClick = () => {
    this.setState({
      value: "",
      list: [...this.state.list, this.state.value],
    });
  };

  onApplyFilter = () => {
    this.props.onApplyFilter && this.props.onApplyFilter(this.state);
  };

  onKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.onAddClick();
    }
  };

  removeItem = (elementIndex) => {
    this.setState({
      list: this.state.list.filter((value, index) => index !== elementIndex),
    });
  };
  render() {
    return (
      <>
        <div className="p-2 filter-container">
          <span className="search-filter">
            <input
              className="search-filter-input add-filter-input"
              value={this.state.value}
              onChange={this.onChange}
              placeholder="Input a value"
              onKeyPress={this.onKeyPress}
            />
            {this.state.value.trim().length > 0 && (
              <span
                className="search-filter-clean button-list"
                onClick={this.onAddClick}
              >
                +
              </span>
            )}
          </span>
          <ul>
            {this.state.list.map((value, i) => (
              <li key={i} className="filter-menu-opt-item">
                {value}
                <span
                  className="filter-remove-item-button button-list"
                  onClick={() => this.removeItem(i)}
                >
                  -
                </span>
              </li>
            ))}
          </ul>
        </div>
        <FilterSelectAddFilterButton
          disabled={this.state.list.length === 0}
          onClick={this.onApplyFilter}
        />
      </>
    );
  }
}

export default LogicalOperatorContainsView;
